import { z } from 'zod';

const CONTROL_VARIABLE_PLACES_TO_HIDE = [
  'readinessScoreExplanations',
  'keyFactors',
] as const;

export const ControlVariablePlaceToHideValue = z
  .enum(CONTROL_VARIABLE_PLACES_TO_HIDE)
  .describe('ControlVariablePlaceToHideValue');

export type ControlVariablePlaceToHideValue = z.infer<
  typeof ControlVariablePlaceToHideValue
>;

const PLACE_TO_HIDE_LABELS = {
  readinessScoreExplanations: 'Readiness Score Explanations',
  keyFactors: 'Key Factors',
} satisfies Record<ControlVariablePlaceToHideValue, string>;

export const ControlVariablePlaceToHideOption = z
  .object({
    label: z.string(),
    value: ControlVariablePlaceToHideValue,
  })
  .describe('ControlVariablePlaceToHideOption');

export type ControlVariablePlaceToHideOption = z.infer<
  typeof ControlVariablePlaceToHideOption
>;

export const ControlVariablePlacesToHideOptions =
  CONTROL_VARIABLE_PLACES_TO_HIDE.map((value) => ({
    label: PLACE_TO_HIDE_LABELS[value],
    value,
  }));
